import axios from 'axios';

export default {
  fetchDepartment({
    commit,
  }, id) {
    return axios.get(`/department/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'department',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  saveDepartment(_, department) {
    return axios.post('/department', department);
  },
};
